import React from "react";
import { GlobalProvider } from "./context/GlobalContext";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./component/Layout";
import Home from "./component/Home";
import Job from "./component/Job";
import Login from "./component/Login";
import Register from "./component/Register";
import Dashboard from "./component/Dashboard";
import Dashboard2 from "./component/Dashboard2";
import Dashboard3 from "./component/Dashboard3";
import Dashboard4 from "./component/Dashboard4";
import JobDetail from "./component/JobDetail";
import NotFound from "./component/404NotFound";
import OnlyAdmin from "./component/OnlyAdmin";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import ProtectedRoute from "./component/ProtectedRoute";

function App() {
  const LoginRoute = (props) => {
    if (Cookies.get("token") === undefined) {
      return <Navigate to={"/onlyAdmin"} />;
    } else if (Cookies.get("token") !== undefined) {
      return props.children;
    }
  };

  const LoginRoute2 = (props) => {
    if (Cookies.get("token") !== undefined) {
      return <Navigate to={"/"} />;
    } else if (Cookies.get("token") === undefined) {
      return props.children;
    }
  };

  return (
    <BrowserRouter>
      <GlobalProvider>
        <Routes>
          <Route
            path="*"
            element={
              <Layout>
                <NotFound />
              </Layout>
            }
          />

          <Route
            path="/"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />

          <Route
            path="/login"
            element={
              <Layout>
                <LoginRoute2>
                  <Login />
                </LoginRoute2>
              </Layout>
            }
          />

          <Route
            path="/register"
            element={
              <Layout>
                <Register />
              </Layout>
            }
          />
          <Route
            path="/job-vacancy"
            element={
              <Layout>
                <Job />
              </Layout>
            }
          />

          <Route
            path="/onlyAdmin"
            element={
              <Layout>
                <OnlyAdmin />
              </Layout>
            }
          />

          <Route
            path="/dashboard"
            element={
              <Layout>
                <LoginRoute>
                  <Dashboard />
                </LoginRoute>
              </Layout>
            }
          />

          <Route
            path="/dashboard/list-job-vacancy"
            element={
              <Layout>
                <Dashboard2 />
              </Layout>
            }
          />

          <Route
            path="/dashboard/list-job-vacancy/edit/:idData"
            element={
              <Layout>
                <Dashboard3 />
              </Layout>
            }
          />

          <Route
            path="/dashboard/list-job-vacancy/create"
            element={
              <Layout>
                <Dashboard4 />
              </Layout>
            }
          />

          <Route
            path="/job-vacancy/:idData"
            element={
              <Layout>
                <JobDetail />
              </Layout>
            }
          />
        </Routes>
      </GlobalProvider>
    </BrowserRouter>
  );
}

export default App;
